import { de, fr } from 'Globals/locale'
import { createContext } from 'react'
interface GlobalContext extends MicroFrontendProps {
  locale: typeof de | typeof fr
}
const GlobalContext = createContext<GlobalContext | undefined>(undefined)
export default GlobalContext
